export const RoomSidebarTestIds = {
  containerRightsidebar: 'container_rightsidebar',
  containerRightsidebarcontent: 'container_rightsidebarcontent',
  textRoomName: 'text_room_name',
  textRoomTopic: 'text_room_topic',
  buttonDescription: 'button_description',
  dropdownChatParticipant: 'dropdown_chat_participant',
  listChatParticipant: 'list_chat_participant',
  iconKickMember: 'icon_kick_member',
  listPinnedmessages: 'list_pinnedmessages',
  buttonHideroomsidebar: 'button_hideroomsidebar',
  memberNameDetails: 'member-name-details',
  buttonInvitemembers: 'button_invitemembers',
  buttonLeaveroom: 'button_leaveroom',
  buttonForgetroom: 'button_forgetroom',
  buttonArchiveroom: 'button_archiveroom',
  buttonRoomsettings: 'button_roomsettings',
  buttonMedia: 'button_media',
  dropdownPinned: 'dropdown_pinned',
  statusIcon: 'status_icon',
  buttonCancelLeaveroom: 'button_cancel_leaveroom',
  buttonConfirmLeaveroom: 'button_confirm_leaveroom',
  dialogLeavingContent: 'dialog_leaving_content',
  dialogLeavingActions: 'dialog_leaving_actions',
  buttonConfirmForgetroom: 'button_confirm_forgetroom'
} as const;
